export default __webpack_public_path__ + "static/media/1635.54499fd4.png";